import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addWeeklySchedule = async (weeklySchedule) => {
    return axios.post(`${BACKEND_URL}/weeklySchedules`, weeklySchedule);
};

export const deleteWeeklySchedule = async (email, year, calendarWeek) => {
    return axios.delete(`${BACKEND_URL}/weeklySchedules/${email}/${year}/${calendarWeek}`);
};

export const getWeeklyScheduleOfAthlete = async (email, year, calendarWeek) => {
    return axios.get(`${BACKEND_URL}/weeklySchedules/${email}/${year}/${calendarWeek}`);
};